const carouselQueryParams = ({ article_id }) => ({
    context_referrer: `content_landing_page_${article_id}`,
    source_type: 'carousel',
    article: article_id
});

const linkQueryParams = ({ article_id }) => ({
    context_referrer: 'content_landing_page',
    source_type: 'link',
    article: article_id
});

const carouselQueryParamEnrichments = (params) => ({
    queryParameters: carouselQueryParams(params),
    gigQueryParams: carouselQueryParams(params),
    sellerQueryParams: carouselQueryParams(params)
});

const linksQueryParamEnrichments = (params) => ({
    queryParametersLink: linkQueryParams(params)
});

module.exports = {
    carouselQueryParamEnrichments,
    linksQueryParamEnrichments
};
